import { Link } from "react-router-dom";
import { MapPin, ExternalLink } from "lucide-react";
import { COMPANY } from "../../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#1F2933] text-white/80 pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
      <div>
        <p className="font-heading font-bold text-white text-lg">FLIESEN-GEFFKE</p>
        <p className="text-xs uppercase tracking-[0.2em] text-[#C9B79C] mb-4">Meisterbetrieb Hamburg</p>
        <p className="text-sm leading-relaxed">
          Inhaber: {COMPANY.owner}<br />
          {COMPANY.ownerTitle}<br />
          Gegründet am {COMPANY.founded}
        </p>
      </div>

      <div data-testid="footer-impressum-block">
        <h3 className="font-heading font-semibold text-white text-sm uppercase tracking-wider mb-4">Impressum</h3>
        <p className="text-sm leading-relaxed">
          {COMPANY.name} · {COMPANY.owner}<br />
          {COMPANY.street}, {COMPANY.city}<br />
          Telefon: <a href={COMPANY.phoneLink} className="hover:text-[#C9B79C] transition-colors">{COMPANY.phone}</a><br />
          Fax: {COMPANY.fax}<br />
          E-Mail: <a href={`mailto:${COMPANY.email}`} className="hover:text-[#C9B79C] transition-colors">{COMPANY.email}</a><br />
          USt-IdNr.: {COMPANY.vatId}<br />
          Eingetragen: {COMPANY.register}
        </p>
      </div>

      <div data-testid="footer-hours-block">
        <h3 className="font-heading font-semibold text-white text-sm uppercase tracking-wider mb-4">Öffnungszeiten</h3>
        <ul className="text-sm space-y-1">
          {COMPANY.hours.map((h) => (
            <li key={h.days}><span className="text-white font-semibold">{h.days}:</span> {h.time}</li>
          ))}
        </ul>
        <div className="mt-6 space-y-2">
          <Link to="/impressum" data-testid="footer-link-impressum" className="block text-sm underline hover:text-[#C9B79C] transition-colors">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-link-datenschutz" className="block text-sm underline hover:text-[#C9B79C] transition-colors">Datenschutzerklärung</Link>
        </div>
      </div>

      <div>
        <h3 className="font-heading font-semibold text-white text-sm uppercase tracking-wider mb-4">Anfahrt</h3>
        <a
          href={COMPANY.mapsLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-map-link"
          className="block group border border-white/15 bg-white/5 p-6 transition-colors hover:border-[#C9B79C]/60"
        >
          <MapPin size={26} className="text-[#B5651D] mb-3" />
          <p className="text-sm font-semibold text-white">{COMPANY.street}</p>
          <p className="text-sm">{COMPANY.city} ({COMPANY.district})</p>
          <p className="mt-3 inline-flex items-center gap-1.5 text-xs uppercase tracking-wider text-[#C9B79C]">
            In Google Maps öffnen <ExternalLink size={12} />
          </p>
        </a>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/50">
      <p>© {new Date().getFullYear()} {COMPANY.name} · Alle Rechte vorbehalten</p>
      <p>Tätig in ganz Hamburg und Umgebung</p>
    </div>
  </footer>
);
